import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/pages/AuthRecovery.css";
import API_BASE from "../api";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      alert(
        t("forgot_password_error_email_required", {
          defaultValue: "Please enter your email address.",
        })
      );
      return;
    }

    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("email", trimmedEmail);

      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        setIsLoading(false);
        alert(
          t("forgot_password_error_server", {
            defaultValue: "Something went wrong. Please try again.",
          })
        );
        return;
      }

      setIsLoading(false);
      setSubmitted(true);
    } catch (err) {
      setIsLoading(false);
      console.error("Forgot password error:", err);
      alert(
        t("forgot_password_error_server", {
          defaultValue: "Something went wrong. Please try again.",
        })
      );
    }
  };

  if (submitted) {
    return (
      <div className="auth-recovery-page">
        <div className="auth-recovery-card">
          <h2 className="auth-recovery-title">
            {t("forgot_password_sent_title", { defaultValue: "Check your email" })}
          </h2>
          <p className="auth-recovery-text">
            {t("forgot_password_sent_message", {
              defaultValue:
                "If an account exists for that email address, you will receive a reset link shortly.",
            })}
          </p>
          <p className="auth-recovery-text">
            {t("forgot_password_sent_spam_note", {
              defaultValue:
                "If you do not see the email within a few minutes, please check your spam or junk folder.",
            })}
          </p>
          <p className="auth-recovery-footer">
            <Link to="/login" className="auth-recovery-link">
              {t("back_to_login", { defaultValue: "Back to login" })}
            </Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-recovery-page">
      <div className="auth-recovery-card">
        <h2 className="auth-recovery-title">
          {t("forgot_password_title", { defaultValue: "Reset your password" })}
        </h2>
        <p className="auth-recovery-text">
          {t("forgot_password_instructions", {
            defaultValue:
              "Enter your email address and we will send you a reset link.",
          })}
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="forgot-password-email" className="sr-only">
            {t("email", { defaultValue: "Email address" })}
          </label>
          <input
            id="forgot-password-email"
            name="email"
            autoComplete="email"
            type="email"
            placeholder={t("email", { defaultValue: "Email address" })}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="auth-recovery-input"
          />
          <button
            type="submit"
            className="auth-recovery-btn"
            disabled={isLoading}
          >
            {isLoading
              ? t("forgot_password_loading", { defaultValue: "Sending…" })
              : t("forgot_password_submit", { defaultValue: "Send reset link" })}
          </button>
        </form>

        <p className="auth-recovery-footer">
          <Link to="/login" className="auth-recovery-link">
            {t("back_to_login", { defaultValue: "Back to login" })}
          </Link>
        </p>
      </div>
    </div>
  );
}
